import { CouponResponse, ErrorResponse, ServiceResponse } from '@bzbs/react-api-client';
import React, { createContext, useContext, useState } from 'react';
import { useBuzzebeesServiceContext } from './buzzebees_service_provider';

type CouponContextType = {
  isLoading: boolean;
  error: ErrorResponse | null;
  actions: {
    process: (codes: string[]) => Promise<ServiceResponse<CouponResponse>>;
  };
};

const CouponContext = createContext({
  isLoading: false,
  error: null,
  actions: {
    process: async () => ({ type: 'client-error', message: 'Not implemented' }),
  },
} as CouponContextType);

export function useCouponContext() {
  return useContext(CouponContext);
}

export function CouponProvider({ children }: { children: React.ReactNode }) {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<ErrorResponse | null>(null);

  const { bzbsService } = useBuzzebeesServiceContext();

  const process = async (codes: string[]): Promise<ServiceResponse<CouponResponse>> => {
    setIsLoading(true);
    const response = await bzbsService.couponApi.processCodes({ codes: codes.join(',') });
    setIsLoading(false);

    if (response.type === 'success') {
      setError(null);
    } else {
      setError(response);
    }

    return response;
  };

  return (
    <CouponContext.Provider
      value={{
        isLoading,
        error,
        actions: {
          process,
        },
      }}
    >
      {children}
    </CouponContext.Provider>
  );
}
